// import StepperProgress from "../Reusablesteps/Stepperprogress";
// import {
//   BtnBack,
//   BtnContinue,
// } from "../Reusablecomponents/Button/Reusableutton";
// import { useAuth } from "../../hooks/useAuth";
// import { useEffect } from "react";

// const AGE_OPTIONS = [
//   "10–14 years",
//   "15–19 years",
//   "20–25 years",
//   "26–35 years",
//   "36–45 years",
//   "46–55 years",
//   "55–64 years",
//   "65+ years",
// ];

// const MARITAL_OPTIONS = [
//   "Single",
//   "Married",
//   "Partnered",
//   "Divorced",
//   "Widowed",
//   "Prefer not to say",
// ];

// const OCCUPATION_OPTIONS = [
//   "Student",
//   "Working",
//   "Home maker",
// ];

// export default function ProfileScreen({
//   onNext,
//   onBack,
//   patientState,
//   onPatientStateChange,
//   stepIndex,
//   totalSteps,
// }) {
//   const {
//     ageGroup,
//     marital,
//     occupation,
//   } = patientState;

//   const { user } = useAuth();
//     // const isVerified = isMobileVerified(mobile || user?.mobile || '');

//     // Pre-fill from auth session only once (when fields are empty)
//     useEffect(() => {
//       if (!user) return;
//       if (!ageGroup && user.ageGroup) set({ ageGroup: user.ageGroup });
//       if (!marital && user.maritalStatus) set({ marital: user.maritalStatus });
//       if (!occupation && user.occupation) set({ occupation: user.occupation });
//     }, [user]);

//   const set = onPatientStateChange;

//   const canContinue =
//     ageGroup &&
//     marital &&
//     occupation;

//   const Chip = ({
//     label,
//     selected,
//     onClick,
//   }) => (
//     <button
//       onClick={onClick}
//       className={`px-3.5 py-1.5 rounded text-[11px]
//       ${
//         selected
//           ? "border-2 border-[#4A148C] text-[#4A148C] font-semibold"
//           : "border border-[#E6E0F0]"
//       }`}
//     >
//       {label}
//     </button>
//   );

//   return (
//     <>
//       <div className="flex items-start justify-between mb-5">
//         <div>
//           <h1 className="text-[22px] font-bold">
//             Tell us about yourself
//           </h1>

//           <p className="text-xs text-[#555555]">
//             This helps personalise your care.
//           </p>
//         </div>

//         {totalSteps ? (
//           <StepperProgress
//             current={stepIndex}
//             total={totalSteps}
//           />
//         ) : null}
//       </div>

//       <div className="flex gap-4 items-start">
//         <div className="flex-1">
//           <div className="bg-white rounded-xl border border-[#E6E0F0] p-4">
//             <p className="text-[11px] font-bold mb-2">
//               Age Group
//             </p>

//             <div className="flex flex-wrap gap-2 mb-4">
//               {AGE_OPTIONS.map((a) => (
//                 <Chip
//                   key={a}
//                   label={a}
//                   selected={ageGroup === a}
//                   onClick={() =>
//                     set({
//                       ageGroup: a,
//                     })
//                   }
//                 />
//               ))}
//             </div>

//             <p className="text-[11px] font-bold mb-2">
//               Marital Status
//             </p>

//             <div className="flex flex-wrap gap-2 mb-4">
//               {MARITAL_OPTIONS.map((m) => (
//                 <Chip
//                   key={m}
//                   label={m}
//                   selected={marital === m}
//                   onClick={() =>
//                     set({
//                       marital: m,
//                     })
//                   }
//                 />
//               ))}
//             </div>

//             <p className="text-[11px] font-bold mb-2">
//               Occupation
//             </p>

//             <div className="flex flex-wrap gap-2">
//               {OCCUPATION_OPTIONS.map((o) => (
//                 <Chip
//                   key={o}
//                   label={o}
//                   selected={occupation === o}
//                   onClick={() =>
//                     set({
//                       occupation: o,
//                     })
//                   }
//                 />
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="flex justify-between mt-5">
//         <BtnBack
//           variant="outline"
//           onClick={onBack}
//         />

//         <BtnContinue
//           variant="primary"
//           disabled={!canContinue}
//           onClick={() =>
//             onNext({
//               ageGroup,
//               marital,
//               occupation,
//             })
//           }
//           label="Save & Continue"
//         />
//       </div>
//     </>
//   );
// }
import StepperProgress from "../Reusablesteps/Stepperprogress";
import {
  BtnBack,
  BtnContinue,
} from "../Reusablecomponents/Button/Reusableutton";
import { useAuth } from "../../hooks/useAuth";
import { useEffect } from "react";
// import content from "./CareJourney.json";
import { ScreenHeaderDFO } from "../HealthAssessment/SharedUI";
import { useCareJourneyContent } from "../../hooks/useCareJourneyContent";
export const updatePatientPersona = (updates) => {
  const patientPersona = JSON.parse(
    localStorage.getItem("patientPersona") || "{}"
  );

  localStorage.setItem(
    "patientPersona",
    JSON.stringify({
      ...patientPersona,
      ...updates,
      updatedAt: Date.now(),
    })
  );
};
export default function ProfileScreen({
  onNext,
  onBack,
  patientState,
  onPatientStateChange,
  stepIndex,
  totalSteps,
}) {
  const { content, loading, error } = useCareJourneyContent();

  const S = content?.screens?.profile;
  // console.log("CareJourney content:", content);
  // console.log("profile screen:", content?.screens?.profile);
  const {
    ageGroup,
    marital,
    occupation,
  } = patientState;


  const { user } = useAuth();

  // Pre-fill from auth session only once (when fields are empty)
  const set = onPatientStateChange;

  useEffect(() => {
    try {
      const saved = JSON.parse(localStorage.getItem("patientPersona") || "null");
      if (!saved) return;

      const patch = {};
      if (!ageGroup && saved.ageGroup) patch.ageGroup = saved.ageGroup;
      if (!marital && saved.marital) patch.marital = saved.marital;
      if (!occupation && saved.occupation) patch.occupation = saved.occupation;

      if (Object.keys(patch).length > 0) set(patch);
    } catch (e) {
      console.error("Failed to read patientPersona from localStorage", e);
    }
    // run once on mount — deliberately not depending on ageGroup/marital/occupation
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!user) return;
    if (!ageGroup && user.ageGroup) set({ ageGroup: user.ageGroup });
    if (!marital && user.maritalStatus) set({ marital: user.maritalStatus });
    if (!occupation && user.occupation) set({ occupation: user.occupation });
  }, [user]);

  if (!S) {
    console.error("profile config missing from femcare-content.json");
    return null;
  }


  const canContinue =
    ageGroup &&
    marital &&
    occupation;

  const Chip = ({
    label,
    selected,
    onClick,
  }) => (
    <button
      onClick={onClick}
      className={`px-3.5 py-1.5 rounded text-[11px]
      ${selected
          ? "border-2 border-[#4A148C] text-[#4A148C] font-semibold"
          : "border border-[#E6E0F0]"
        }`}
    >
      {label}
    </button>
  );

  return (
    <>
      {/* <ScreenHeaderDFO /> */}
      <div className="flex items-start justify-between mb-5 flex-wrap">
        <div>
          <h1 className="text-[22px] font-bold">
            {S.pageTitle}
          </h1>

          <p className="text-xs text-[#555555]">
            {S.pageSubtitle}
          </p>
        </div>

        {totalSteps ? (
          <StepperProgress
            current={stepIndex}
            total={totalSteps}
          />
        ) : null}
      </div>

      <div className="flex gap-4 items-start">
        <div className="flex-1">
          <div className="bg-white rounded-xl border border-[#E6E0F0] p-4">
            <p className="text-[11px] font-bold mb-2">
              {S.sections.ageGroup.label}
            </p>

            <div className="flex flex-wrap gap-2 mb-4">
              {S.sections.ageGroup.options.map((a) => (
                <Chip
                  key={a}
                  label={a}
                  selected={ageGroup === a}
                  onClick={() =>
                    set({
                      ageGroup: a,
                    })
                  }
                />
              ))}
            </div>

            <p className="text-[11px] font-bold mb-2">
              {S.sections.maritalStatus.label}
            </p>

            <div className="flex flex-wrap gap-2 mb-4">
              {S.sections.maritalStatus.options.map((m) => (
                <Chip
                  key={m}
                  label={m}
                  selected={marital === m}
                  onClick={() =>
                    set({
                      marital: m,
                    })
                  }
                />
              ))}
            </div>

            <p className="text-[11px] font-bold mb-2">
              {S.sections.occupation.label}
            </p>

            <div className="flex flex-wrap gap-2">
              {S.sections.occupation.options.map((o) => (
                <Chip
                  key={o}
                  label={o}
                  selected={occupation === o}
                  onClick={() =>
                    set({
                      occupation: o,
                    })
                  }
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-between mt-5">
        <BtnBack
          variant="outline"
          onClick={onBack}
        />

        <BtnContinue
          variant="primary"
          disabled={!canContinue}
          // onClick={() =>
          //   onNext({
          //     ageGroup,
          //     marital,
          //     occupation,
          //   })
          // }
          onClick={() => {
            updatePatientPersona({
              ageGroup,
              marital,
              maritalStatus: marital,
              occupation,
            });

            onNext({
              ageGroup,
              marital,
              occupation,
            });
          }}
          label={S.buttons.continue.label}
        />
      </div>
    </>
  );
}